<template>
    <date-pick
            v-model="dob"
            :displayFormat="'DD-MM-YYYY'"
    ></date-pick>
</template>

<style>
    .vdpTable {
        font-size: 10px;
    }

    .vdpClearInput{
        display: none;
    }

    .vdpComponent, .vdpComponent .form-control{
        height: 40px !important;
    }

</style>

<script>
    import DatePick from 'vue-date-pick';

    export default {
        components: {DatePick},
        props: {
            current: {
                type: String,
                required: false,
                default: '',
            },
        },
        data: () => ({
            dob: '',
            currentDate:''
        }),
        mounted() {
            this.currentDate = this.current;
            document.getElementsByClassName('vdpComponent')[0].classList.add('form-control');
            document.getElementsByClassName('vdpComponent')[0].style.padding = '0';
            document.getElementsByClassName('vdpComponent')[0].getElementsByTagName('input')[0].classList.add('form-control');
            document.getElementsByClassName('vdpComponent')[0].getElementsByTagName('input')[0].setAttribute('name', 'dob');
            document.getElementsByClassName('vdpComponent')[0].getElementsByTagName('input')[0].setAttribute("autocomplete", "off");
            document.getElementsByClassName('vdpComponent')[0].getElementsByTagName('input')[0].setAttribute("value", this.currentDate);
        }
    };
</script>
